import { render, staticRenderFns } from "./ViewMovementsField.vue?vue&type=template&id=140fa2bc&scoped=true"
import script from "./ViewMovementsField.vue?vue&type=script&lang=js"
export * from "./ViewMovementsField.vue?vue&type=script&lang=js"
import style0 from "./ViewMovementsField.vue?vue&type=style&index=0&id=140fa2bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140fa2bc",
  null
  
)

export default component.exports